import i18n from '@/libs/i18n'

const { t } = i18n.global

enum Errors {
    InternalServerError = 1,
    InvalidData,
    NotFound,
    Unauthorized,
    UserExist,
    UserDoesNotExist,
    RoleExists,
    RoleDoesNotExist,
    UnableToRetrieveExtension,
    ChannelCategoryIsAppliedAtChannel,
    DistributionZoneIsAppliedAtWorker,
    FileToBig,
    MissingRoles,
    IncorrectPassword,
    ChannelMappingAlreadyExists,
    ErrFetchingData,
    ErrDeletingDefaultData,
    DataAlreadyExists,
    FailedToInsert,
    ProfileInUse,
    LiveMediaSourceForChannelWithProfileExists,
    ChannelInUse,
    WrongProvider,
    WrongChallengeType,
    ErrExternalIdExists,
    ErrClientDoesNotExist,
    DistributionZoneInUse,
    ErrPackageAlreadyActivated,
    ErrPackageValidUntilMustBeAfterCurrentTime,
    ErrPackageIsNotActivated,
    ErrChannelPackageDoesNotExist,
    ErrAPIKeyExpired,
    ErrAPIKeyNameExists,
    ErrInvalidDomain,
    ErrCantToggleEnabledAtDefaultDistributionZone,
    ErrUsernameExists,
    ErrMaxAllowedDevices,
    ErrChannelWithPositionExists,
    ErrWorkerNameExists
}

const parseError = (errorObject: unknown, fallback = '') => {
    if (errorObject === null || errorObject === undefined
        || !(errorObject instanceof Object)
        || !('error' in errorObject)
        || !errorObject.error
        || !(errorObject.error instanceof Object)
        || !('code' in errorObject.error)
        || errorObject.error.code === Errors.InternalServerError) {
        if (fallback && fallback !== '') return fallback
        return t('errors.generic_error')
    }

    switch (errorObject.error.code) {
        case Errors.InvalidData:
            return t('errors.invalid_data')
        case Errors.NotFound:
            return t('errors.not_found')
        case Errors.Unauthorized:
            return t('errors.unauthorized')
        case Errors.UserExist:
            return t('errors.user_exist')
        case Errors.UserDoesNotExist:
            return t('errors.user_does_not_exist')
        case Errors.RoleExists:
            return t('errors.role_exists')
        case Errors.RoleDoesNotExist:
            return t('errors.role_does_not_exist')
        case Errors.UnableToRetrieveExtension:
            return t('errors.unable_to_retrieve_extension')
        case Errors.ChannelCategoryIsAppliedAtChannel:
            return t('errors.channel_category_is_applied_at_channel')
        case Errors.FileToBig:
            return t('errors.file_to_big')
        case Errors.MissingRoles:
            return t('errors.missing_roles')
        case Errors.IncorrectPassword:
            return t('errors.incorrect_password')
        case Errors.ChannelMappingAlreadyExists:
            return t('errors.channel_mapping_already_exists')
        case Errors.ErrFetchingData:
            return t('errors.fetching_data')
        case Errors.ErrDeletingDefaultData:
            return t('errors.deleting_default_data')
        case Errors.DataAlreadyExists:
            return t('errors.data_already_exists')
        case Errors.FailedToInsert:
            return t('errors.failed_to_insert')
        case Errors.ProfileInUse:
            return t('errors.profile_in_use')
        case Errors.LiveMediaSourceForChannelWithProfileExists:
            return t('errors.live_media_source_for_channel_with_profile_exists')
        case Errors.ChannelInUse:
            return t('errors.channel_in_use')
        case Errors.DistributionZoneIsAppliedAtWorker:
            return t('errors.distribution_zone_applied_at_worker')
        case Errors.WrongProvider:
            return t('errors.wrong_provider')
        case Errors.WrongChallengeType:
            return t('errors.wrong_challenge_type')
        case Errors.ErrExternalIdExists:
            return t('errors.external_id_exists')
        case Errors.ErrClientDoesNotExist:
            return t('errors.client_does_not_exist')
        case Errors.DistributionZoneInUse:
            return t('errors.distribution_zone_in_use')
        case Errors.ErrPackageAlreadyActivated:
            return t('errors.package_already_activated')
        case Errors.ErrPackageValidUntilMustBeAfterCurrentTime:
            return t('errors.package_valid_until_must_be_after_current_time')
        case Errors.ErrPackageIsNotActivated:
            return t('errors.package_is_not_activated')
        case Errors.ErrAPIKeyExpired:
            return t('errors.api_key_expired')
        case Errors.ErrAPIKeyNameExists:
            return t('errors.api_key_name_exists')
        case Errors.ErrInvalidDomain:
            return t('errors.invalid_domain')
        case Errors.ErrCantToggleEnabledAtDefaultDistributionZone:
            return t('errors.cant_toggle_enabled_default_distribution_zone')
        case Errors.ErrUsernameExists:
            return t('errors.username_exists')
        case Errors.ErrMaxAllowedDevices:
            return t('errors.max_allowed_devices_reached')
        case Errors.ErrChannelWithPositionExists:
            return t('errors.channel_with_position_exists')
        case Errors.ErrWorkerNameExists:
            return t('errors.worker_name_exists')
        default:
            return t('errors.generic_error')
    }
}

export { parseError }
